/* eslint-disable @typescript-eslint/naming-convention */
import type { ToggleBlock, ToggleOptionBlock } from '@ps/web-martech-cms-types/Form';
import { ToggleGroup, useDisplayLabel } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import formStyles from '../../CMSForm.scss';

import SingleToggle from './SingleToggle';
import type { ToggleType } from './SingleToggle';
import styles from './ToggleInput.scss';

const ToggleInput: React.FC<ToggleBlock['toggle']> = ({
  type,
  field_name,
  group_label,
  toggle_options,
  required_validation
}) => {
  const {
    meta,
    input: { value: fieldValue }
  } = useField(field_name);
  const displayLabel = useDisplayLabel(meta?.error?.message);
  const labelComponent = (
    <>
      {group_label}
      {required_validation.active && <span className={formStyles.requiredIndicator}>*</span>}
    </>
  );

  return (
    <ToggleGroup
      id={field_name}
      name={field_name}
      label={labelComponent}
      labelClassName={styles.label}
      className={styles.toggleGroup}
    >
      {toggle_options.map((input: ToggleOptionBlock) => (
        <SingleToggle
          key={input.value}
          type={type as ToggleType}
          input={input}
          field_name={field_name}
          fieldValue={fieldValue}
          requiredValidation={required_validation}
        />
      ))}
      {(meta.touched || meta.dirty) && meta.error && meta.error.message && (
        <p className={styles.error}>{displayLabel}</p>
      )}
    </ToggleGroup>
  );
};

export default ToggleInput;
